"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterableListTab = exports.typeIconNameMapping = void 0;
var React = require("react");
var search_1 = require("src/search");
exports.typeIconNameMapping = (_a = {},
    _a[search_1.FullTextSearchFilterTypeKeys.ALL] = 'search-icon',
    _a[search_1.FullTextSearchFilterTypeKeys.DOCUMENTATION] = 'documents-icon',
    _a[search_1.FullTextSearchFilterTypeKeys.DRAWINGS] = 'documents-icon',
    _a[search_1.FullTextSearchFilterTypeKeys.PRODUCTS] = 'products-icon',
    _a[search_1.FullTextSearchFilterTypeKeys.DOWNLOAD] = 'downloads-icon',
    _a[search_1.FullTextSearchFilterTypeKeys.CAREERS] = 'jobs-icon',
    _a[search_1.FullTextSearchFilterTypeKeys.COURSE] = 'learning-icon',
    _a);
exports.FilterableListTab = React.forwardRef(function (props, tabRef) {
    var tabDetails = props.tabDetails, onTabSwitch = props.onTabSwitch, selected = props.selected, tabIndex = props.tabIndex;
    var iconName = exports.typeIconNameMapping[tabDetails.value];
    var onTabClickHandler = React.useCallback(function () {
        if (selected)
            return;
        onTabSwitch(tabDetails.value, tabIndex);
    }, [onTabSwitch, selected, tabDetails.value, tabIndex]);
    var documentCountVisible = typeof tabDetails.documentsCount === 'number';
    return (React.createElement("li", { className: "filterable-list__tab-wrapper", ref: tabRef, role: "presentation" },
        React.createElement("button", { role: "tab", type: "button", className: "filterable-list__tab text-left text-secondary ".concat(selected ? 'filterable-list__tab--active' : ''), onClick: onTabClickHandler, "aria-selected": selected, disabled: selected ? true : false },
            React.createElement("img", { className: "filterable-list__tab-icon", src: "/static/images/".concat(iconName).concat('.svg'), alt: iconName }),
            React.createElement("span", { className: "filterable-list__tab-label whitespace-nowrap" },
                tabDetails.title,
                " ",
                documentCountVisible ? "(".concat(tabDetails.documentsCount, ")") : ''))));
});
